import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const Select = styled.select`
  padding: 10px 16px;
  padding-right: 40px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  background-color: ${cssVars.bgColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;

  &:hover {
    border-color: ${cssVars.primary};
    background-color: ${cssVars.bgSecondary};
  }

  &:focus {
    outline: none;
    border-color: ${cssVars.primary};
    box-shadow: 0 0 0 3px ${cssVars.primary}15;
    background-color: ${cssVars.bgColor};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background-color: ${cssVars.bgSecondary};
  }

  option {
    background-color: ${cssVars.bgColor};
    color: ${cssVars.textPrimary};
    padding: 10px 12px;
    font-size: 14px;
    font-family: inherit;
  }
`;

